import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzIconModule } from 'ng-zorro-antd/icon';

import { CheckEndpointStatusComponent } from './check-endpoint-status.component';

@NgModule({
  declarations: [CheckEndpointStatusComponent],
  exports: [CheckEndpointStatusComponent],
  imports: [
    CommonModule,
    NzIconModule,
  ]
})
export class CheckEndpointStatusModule { }
